module.exports = __webpack_public_path__ + "b0e2fec7011861ebc3273677f26e4fa8.pdf";